var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchbarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 46,
    viewBox: "0 0 56 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_28_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 46,
    rx: 8,
    fill: "url(#paint0_linear_28_13)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 25.6667H31.6133L31.24 25.3067C32.5467 23.7867 33.3333 21.8133 33.3333 19.6667C33.3333 14.88 29.4533 11 24.6667 11C19.88 11 16 14.88 16 19.6667C16 24.4533 19.88 28.3333 24.6667 28.3333C26.8133 28.3333 28.7867 27.5467 30.3067 26.24L30.6667 26.6133V27.6667L37.3333 34.32L39.32 32.3333L32.6667 25.6667ZM24.6667 25.6667C21.3467 25.6667 18.6667 22.9867 18.6667 19.6667C18.6667 16.3467 21.3467 13.6667 24.6667 13.6667C27.9867 13.6667 30.6667 16.3467 30.6667 19.6667C30.6667 22.9867 27.9867 25.6667 24.6667 25.6667Z",
    fill: "#76D0D5"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 45,
    rx: 7.5,
    stroke: "url(#paint1_radial_28_13)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 45,
    rx: 7.5,
    stroke: "url(#paint2_radial_28_13)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 45,
    rx: 7.5,
    stroke: "url(#paint3_radial_28_13)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_28_13",
    x: -42,
    y: -42,
    width: 140,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_28_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_28_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_13",
    x1: 4.5,
    y1: 3,
    x2: 52,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_28_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 23) rotate(-138.207) scale(47.9215 37.075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_28_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 23) rotate(35.2235) scale(41.1307 28.1605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76D0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608B97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_28_13",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 23) rotate(141.535) scale(39.1936 28.5323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbarIcon);
export default __webpack_public_path__ + "static/media/Searchbar Icon.da223ed5d8002f37aa7ecdcd3fbb3c4e.svg";
export { ForwardRef as ReactComponent };